import { Component, ViewEncapsulation} from '@angular/core';
import { SearchModel } from '../../models/search.model';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { MagasinService } from '../../services/magasin.service';
import { ServService } from '../../services/serv.service';

@Component({
    selector   : 'my-search',
    template: require('./search.component.html'),
    styles: [require('./search.component.scss')],
    encapsulation: ViewEncapsulation.None
})

export class SearchComponent {

    public minimumCharBeforeSearch: number = 2;
    public panelOpen: boolean = false;
    public searchModel:SearchModel;
    private lastSearch = "";

    constructor(public servService:ServService, public magasinService:MagasinService, private searchService:SearchService, private router: Router, private apiService:ApiService) {
        this.searchModel = new SearchModel(this.searchService);
    }

    unfocus() {
        this.lastSearch = this.searchModel.query;
        this.searchModel.query = "";
    }
    onSearch() {
        if (this.searchModel.query.length >= this.minimumCharBeforeSearch){
            this.search();
            this.panelOpen = true;
        } else {
            this.panelOpen = false;
        }
    }

    search(){
        this.searchModel.modelChange();
    }

    openCustomer(privateId:string){
        this.router.navigate(['/customer', privateId]);
        this.panelOpen = false;
        this.reset();
    }

    openBike(privateId:string){
        this.router.navigate(['/bike', privateId]);
        this.panelOpen = false;
        this.reset();
    }

    createCustomer(){
        this.router.navigate(['/customer/new/', Math.floor(1000 + Math.random() * 9000) + this.lastSearch]);
        this.panelOpen = false;
        this.reset();
    }

    toDouble(num:number){
        return num.toFixed(2);
    }

    reset(){
        this.searchModel.bikes = [];
        this.searchModel.clients = [];
        this.searchModel.query = '';
    }

    logout(){
        this.apiService.logout2();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/search/search.component.ts